import HttpRequest from "../http_request";
class EmployeeApi extends HttpRequest {
  apiCreateEmployee(data) {
    return this.create(`/client/v1/accounts-childs/generate-invite`, data);
  }
  apiGetEmployee(data) {
    return this.fetch(`/client/v1/accounts-childs`, data);
  }
  apiEditsetUpdate(data) {
    return this.edit(`/client/v1/accounts-childs/${data.id}`, data.formData);
  }
  apiDeleteEmployee(id) {
    return this.delete(`/client/v1/accounts-childs/${id}`);
  }
}

export default EmployeeApi;
